import { all } from 'redux-saga/effects'
import { input } from "./input";
import { requiredstatus } from "./requiredstatus";
import { volume } from "./volume";
import {instance} from "./instance";
import {advertisementaudiotiming} from "./advertisementaudiotiming";
import { positions} from "./positions";
import { playedItem } from "./playedItem";
import {qualities} from "./qualities";
import {SagaMiddleware} from "redux-saga";
import {saga} from "./saga";

export function * Saga () {
    yield all([saga(), input(), requiredstatus(), volume(), instance(), advertisementaudiotiming(), positions(), playedItem(), qualities()])
}

export const runSaga = (middleware:  SagaMiddleware<object>) => {

    middleware.run(Saga);
}